import { Injectable } from "@angular/core";

import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { LookupsService } from "../services/lookups.service";

@Injectable({
  providedIn: "root",
})
// Used in order to load up look up country service before page loads
export class LookUpResolver implements Resolve<any> {
  constructor(private lookUpService: LookupsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.lookUpService.getLookupByTableAlias("country");
  }
}
